// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2yboy","topBottomGutter":"Layout_topBottomGutter__1gllx"};